import { Field, Formik, useFormikContext } from "formik";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import T from "./traducao";
import { blockInvalidChar } from "../utils/blockkeys";
import "../styles/botoesBuscar.css";
import DatePickerField from "../components/controls_comp/control-datepicker-field";


const fieldMaxLengths = {
  NomeEstado: 3,
};

const GetCollumns = (props) => {
  const { setFieldValue, handleChange } = useFormikContext();
  const { campos, onSetFocusChanged, onFieldChange } = props;

  const list = campos.map((item) => (
    <option key={item.field} value={item.field} tipo={item.tipo}>
      {item.headerName}
    </option>
  ));

  return (
    <Field name={"searchField"}>
      {({ field }) => (
        <Form.Select
          {...field}
          onChange={(e) => {
            handleChange(e);

            const selectedIndex = e.target.options.selectedIndex;
            const selectedField = campos[selectedIndex].field;

            setFieldValue("tipo", campos[selectedIndex].tipo);
            setFieldValue("searchValue", "");
            setFieldValue("searchFieldTranslate", campos[selectedIndex].translateField);

            onFieldChange && onFieldChange(selectedField);
            onSetFocusChanged && onSetFocusChanged();
          }}
          aria-label="Selecionar campo"
        >
          {list}
        </Form.Select>
      )}
    </Field>
  );
};

const FormObserverFilter = ({ setOperator }) => {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    setOperator && setOperator(values.tipo);
    values.tipo === "text"
      ? setFieldValue("searchoperator", "Contains")
      : setFieldValue("searchoperator", "eq");
  }, [values.tipo]);
};

const SearchComp = (props) => {
  const { title, botaoDisabilitado, to, criarOrcamento, hasBotao, records, storagename } = props;

  const constantes = T();
  const [operator, setOperator] = useState("number");
  const [maxLength, setMaxLength] = useState(50);

  const refInput = useRef(null);

  const first_field = props.campos?.[0] ?? {
    field: "Id",
    headerName: "Código",
    tipo: "Number",
    translateField: "Código",
  };

  const onSearch = props.onSearch?.bind(this);

  function handleFieldChange(field) {
    const limit = fieldMaxLengths[field] ?? 50;
    setMaxLength(limit);
  }

  const getFilter = () => {
    const operatorOptions =
      operator === "text"
        ? [
            { key: "Contains", value: constantes.Contem },
            { key: "StartsWith", value: constantes.Iniciacom },
          ]
        : operator === "checkbox"
        ? [{ key: "eq", value: constantes.Igual }]
        : [
            { key: "eq", value: constantes.Igual },
            { key: "ge", value: constantes.Apartir },
            { key: "le", value: constantes.Ate },
          ];

    return (
      <Field name={"searchoperator"}>
        {({ field }) => (
          <Form.Select {...field} aria-label="Selecionar operador">
            {operatorOptions.map((option, index) => (
              <option key={index} value={option.key}>
                {option.value}
              </option>
            ))}
          </Form.Select>
        )}
      </Field>
    );
  };

  const initialValues = storagename
    ? {
        tipo: localStorage.getItem(`saved_${storagename}`) ?? first_field.tipo,
        searchoperator: localStorage.getItem(`savedSearchOperator_${storagename}`) ?? "eq",
        searchField: localStorage.getItem(`savedSearchField_${storagename}`) ?? first_field.field,
        searchFieldTranslate: localStorage.getItem(`savedSearchFieldTranslate_${storagename}`) ?? first_field.translateField,
        searchValue: "",
      }
    : {
        tipo: first_field.tipo,
        searchoperator: "eq",
        searchField: first_field.field,
        searchFieldTranslate: first_field.translateField,
        searchValue: "",
      };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        if (storagename) {
          localStorage.setItem(`saved_${storagename}`, values.tipo);
          localStorage.setItem(`savedSearchOperator_${storagename}`, values.searchoperator);
          localStorage.setItem(`savedSearchField_${storagename}`, values.searchField);
          if (values.searchFieldTranslate) {
            localStorage.setItem(`savedSearchFieldTranslate_${storagename}`, values.searchFieldTranslate);
          }
        }
        onSearch && onSearch(values);
      }}
    >
      {({ values, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <Container>
            <div className="d-flex align-items-center justify-content-between my-3">
              <h1 className="text-black-50">{title || constantes.Pesquisa}</h1>
              {hasBotao && (
                <Button
                  bsPrefix="ButtonStyle NovoOrcamento"
                  disabled={botaoDisabilitado}
                  href={to}
                  onClick={criarOrcamento}
                >
                  {constantes.Novo}
                </Button>
              )}
            </div>
            <hr />
            <Card>
              <Card.Body>
                <div>
                  <h4>{constantes.PesquisarPor}</h4>
                </div>
                <InputGroup>
                  <FormObserverFilter setOperator={setOperator} />
                  <Container fluid>
                    <Row className="d-flex justify-content-center gap-0">
                      <Col xs={12} md={2}>
                        <GetCollumns
                          {...props}
                          onSetFocusChanged={() => refInput?.current?.focus()}
                          onFieldChange={handleFieldChange}
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        {getFilter()}
                      </Col>
                      <Col>
                        <Field name={"searchValue"}>
                          {({ field }) =>
                            values.tipo === "date" ? (
                              <DatePickerField {...field} {...props} ref={refInput} />
                            ) : values.tipo === "checkbox" ? (
                              <input {...field} ref={refInput} type={values.tipo} />
                            ) : (
                              <input
                                {...field}
                                ref={refInput}
                                type={values.tipo}
                                className="form-control form-control-search"
                                placeholder={constantes.DigiteAPesquisa}
                                onKeyDown={blockInvalidChar}
                                onWheel={(e) => e.target.blur()}
                                maxLength={maxLength}
                              />
                            )
                          }
                        </Field>
                      </Col>
                      <Col xs={12} md={2}>
                        {props.renderButton
                          ? props.renderButton({ disabled: botaoDisabilitado })
                          : <Button bsPrefix="ButtonStyle BtnBuscar" type="submit" disabled={botaoDisabilitado}>
                              {constantes.Buscar}
                            </Button>
                        }
                      </Col>
                    </Row>
                    {records && (
                      <Row>
                        <Col>{constantes.TotalRegistros}</Col>
                        <Col>{records}</Col>
                      </Row>
                    )}
                  </Container>
                </InputGroup>
              </Card.Body>
            </Card>
          </Container>
        </Form>
      )}
    </Formik>
  );
};

export default SearchComp;
